import { FC } from 'react'
import { Spin } from 'antd'
import { useDashboardParams } from 'core/queryParams/useDashboardParams'
import { useGetSignedTrace } from 'lib/queries/useGetSignedTrace/useGetSignedTrace'
import styles from './TraceViewer.module.less'

const TraceViewer: FC = () => {
  const { query } = useDashboardParams()

  const {
    data: { signedUrl } = {},
    isLoading,
    error,
  } = useGetSignedTrace(query)

  if (isLoading) {
    return <Spin size="large" />
  }

  if (error) {
    return <div>{`Error: ${error}`}</div>
  }

  if (!signedUrl) {
    return <div>No trace URL available</div>
  }

  return (
    <iframe
      src={`https://trace.playwright.dev/?trace=${encodeURIComponent(signedUrl)}`}
      title="Trace Viewer"
      className={styles.traceViewerFrame}
    />
  )
}

export default TraceViewer
